import React from 'react';
import MoveToTop from '../UI/MoveToTop/MoveToTop';
import { Link } from 'react-router-dom';
import './Footer.scss';
import FacebookLightIcon from '../Icons/FacebookLightIcon';
import InstagramLightIcon from '../Icons/InstagramLightIcon';
import { PropTypes } from 'prop-types';
import FacebookDarkIcon from '../Icons/FacebookDarkIcon';
import InstagramDarkIcon from '../Icons/InstagramDarkIcon';
import { footerLinks } from './constants';
import {
  NAS_ACADEMY_FB_PAGE,
  NAS_ACADEMY_IG_PAGE,
} from '../../utility/constants';

const footerType = {
  light: 'light',
  dark: 'dark',
};

const Footer = ({ displayType, bottomOffset }) => {
  const currentYear = new Date().getFullYear();
  const className = 'c-Footer';

  const renderLinks = () => {
    return (
      <>
        {footerLinks.map((link, index) => (
          <p
            className={`${className}__site-links__item ${className}__site-links__item--${displayType}`}
            key={`${link.name}-${index}`}
          >
            {link.isExternal ? (
              <a href={link.link} title={link.name}>
                {link.name}
              </a>
            ) : (
              <Link to={link.link} title={link.name}>
                {link.name}
              </Link>
            )}
          </p>
        ))}
      </>
    );
  };

  const footerLogo =
    displayType === footerType.dark
      ? 'https://d2oi1rqwb0pj00.cloudfront.net/na-website/svg/nalogo-white.svg'
      : 'https://d2oi1rqwb0pj00.cloudfront.net/na-website/svg/nalogo-dark.svg';

  const fbLogo =
    displayType === footerType.dark ? (
      <FacebookLightIcon />
    ) : (
      <FacebookDarkIcon />
    );
  const igLogo =
    displayType === footerType.dark ? (
      <InstagramLightIcon />
    ) : (
      <InstagramDarkIcon />
    );

  return (
    <footer
      className={`${className} ${className}--${displayType}`}
      //This offset is added when we have a fixed CTA at the bottom of the page so that the footer doesnt hide partially
      style={!!bottomOffset ? { marginBottom: `${bottomOffset}px` } : {}}
    >
      <div className={`${className}__container`}>
        <div
          className={`${className}__site-links ${className}__site-links--dark`}
        >
          {renderLinks()}
        </div>
        <Link to="/" title="Home Page">
          <img
            className={`${className}__site-links__logo ${className}__site-links__logo--${displayType}`}
            src={footerLogo}
            alt="nasacademy-logo"
          />
          <p
            className={`${className}__site-links__tagline ${className}__site-links__tagline--${displayType}`}
          >
            WE EMPOWER CREATORS.
          </p>
        </Link>
        <ul className={`${className}__social-icons`}>
          <li>
            <Link
              title="Facebook Page"
              to={{ pathname: NAS_ACADEMY_FB_PAGE }}
              target="_blank"
              rel="noopener noreferrer"
            >
              {fbLogo}
            </Link>
          </li>
          <li>
            <Link
              title="Instagram Page"
              to={{ pathname: NAS_ACADEMY_IG_PAGE }}
              target="_blank"
              rel="noopener noreferrer"
            >
              {igLogo}
            </Link>
          </li>
        </ul>
        <p
          className={`${className}__copyright ${className}__copyright--${displayType}`}
        >
          Copyright © {currentYear.toString()} All Rights Reserved by Nas
          Academy
        </p>
      </div>
      <MoveToTop />
    </footer>
  );
};

Footer.defaultProps = {
  displayType: 'dark',
  bottomOffset: 0,
};

Footer.propTypes = {
  displayType: PropTypes.oneOf(['light', 'dark']),
  bottomOffset: PropTypes.number,
};

export default Footer;
